import React from 'react';
import { Card, Row, Col, Statistic, Typography, Space } from 'antd';
import { 
  UserOutlined, 
  TeamOutlined, 
  DatabaseOutlined, 
  CheckCircleOutlined 
} from '@ant-design/icons';
import MainLayout from './MainLayout';

const { Title, Paragraph } = Typography;

const Dashboard = () => {
  // Mock data for dashboard stats - replace with real data
  const stats = [
    {
      title: 'Total Clients',
      value: 24,
      icon: <TeamOutlined style={{ fontSize: '24px', color: '#1890ff' }} />,
      color: '#1890ff'
    },
    {
      title: 'Active Users',
      value: 156,
      icon: <UserOutlined style={{ fontSize: '24px', color: '#52c41a' }} />,
      color: '#52c41a'
    },
    {
      title: 'Database Connections',
      value: 18,
      icon: <DatabaseOutlined style={{ fontSize: '24px', color: '#722ed1' }} />,
      color: '#722ed1'
    },
    {
      title: 'System Health',
      value: '98%',
      icon: <CheckCircleOutlined style={{ fontSize: '24px', color: '#52c41a' }} />,
      color: '#52c41a'
    }
  ];

  return (
    <MainLayout pageTitle="Dashboard">
      <div>
        <Title level={2} style={{ marginBottom: '24px' }}>
          Welcome to Admin Dashboard
        </Title>
        
        <Paragraph style={{ fontSize: '16px', color: '#666', marginBottom: '32px' }}>
          Monitor your system performance, manage clients, and track key metrics from this central dashboard.
        </Paragraph>

        {/* Stats Cards */}
        <Row gutter={[24, 24]} style={{ marginBottom: '32px' }}>
          {stats.map((stat, index) => (
            <Col xs={24} sm={12} lg={6} key={index}>
              <Card>
                <Space direction="vertical" size="small" style={{ width: '100%' }}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <span style={{ fontSize: '14px', color: '#666' }}>{stat.title}</span>
                    {stat.icon}
                  </div>
                  <Statistic
                    value={stat.value}
                    valueStyle={{ color: stat.color, fontSize: '28px', fontWeight: 'bold' }}
                  />
                </Space>
              </Card>
            </Col>
          ))}
        </Row>

        {/* Recent Activity */}
        <Row gutter={[24, 24]}>
          <Col xs={24} lg={12}>
            <Card title="Recent Activity" size="small">
              <div style={{ padding: '16px 0' }}>
                <div style={{ marginBottom: '16px', padding: '12px', background: '#f5f5f5', borderRadius: '6px' }}>
                  <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>New client onboarded</div>
                  <div style={{ fontSize: '12px', color: '#666' }}>TechCorp Solutions was added to the system</div>
                  <div style={{ fontSize: '11px', color: '#999', marginTop: '4px' }}>2 hours ago</div>
                </div>
                <div style={{ marginBottom: '16px', padding: '12px', background: '#f5f5f5', borderRadius: '6px' }}>
                  <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>Database connection updated</div>
                  <div style={{ fontSize: '12px', color: '#666' }}>Global Innovations database credentials refreshed</div>
                  <div style={{ fontSize: '11px', color: '#999', marginTop: '4px' }}>4 hours ago</div>
                </div>
                <div style={{ padding: '12px', background: '#f5f5f5', borderRadius: '6px' }}>
                  <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>System backup completed</div>
                  <div style={{ fontSize: '12px', color: '#666' }}>Daily backup process finished successfully</div>
                  <div style={{ fontSize: '11px', color: '#999', marginTop: '4px' }}>6 hours ago</div>
                </div>
              </div>
            </Card>
          </Col>
          
          <Col xs={24} lg={12}>
            <Card title="Quick Actions" size="small">
              <div style={{ padding: '16px 0' }}>
                <div style={{ marginBottom: '16px', padding: '12px', background: '#f0f9ff', borderRadius: '6px', border: '1px solid #bae6fd' }}>
                  <div style={{ fontWeight: 'bold', marginBottom: '4px', color: '#0369a1' }}>Onboard New Client</div>
                  <div style={{ fontSize: '12px', color: '#666' }}>Add a new client to the system</div>
                </div>
                <div style={{ marginBottom: '16px', padding: '12px', background: '#f0f9ff', borderRadius: '6px', border: '1px solid #bae6fd' }}>
                  <div style={{ fontWeight: 'bold', marginBottom: '4px', color: '#0369a1' }}>View System Logs</div>
                  <div style={{ fontSize: '12px', color: '#666' }}>Check system performance and errors</div>
                </div>
                <div style={{ padding: '12px', background: '#f0f9ff', borderRadius: '6px', border: '1px solid #bae6fd' }}>
                  <div style={{ fontWeight: 'bold', marginBottom: '4px', color: '#0369a1' }}>Generate Reports</div>
                  <div style={{ fontSize: '12px', color: '#666' }}>Create client and system reports</div>
                </div>
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </MainLayout>
  );
};

export default Dashboard;
